class rebuyCustomizations extends HTMLElement {
    constructor() {
        super();
        //bundle constants
        this.bundleDiscounts = [
            28.56, 31.57, 32.25, 34.24
        ]
        
        this.waitForElm("[data-rebuy-id='101408']").then((elm) => {
            console.log("noicee");
            this.rebuyContainer = document.querySelectorAll('[data-rebuy-id]')[0];
            this.rebuyShopifySection = this.rebuyContainer.parentNode.closest('section.shopify-section');
            this.rebuyContainer.parentNode.closest('div.page-width').classList.remove('page-width');
            this.productPosition = document.getElementsByClassName("product__info-container");
            this.productPosition[0].append(this.rebuyShopifySection);
            this.rebuyPrice = document.getElementsByClassName('rebuy-bundle__actions-price-value');
            console.log("noicee error");
            
            let self = this;
            //add event listeners  
            setTimeout(function() { 
                this.inputs = document.querySelectorAll('input.checkbox-input.rebuy-checkbox');
                this.productBlocks = document.querySelectorAll('.rebuy-product-block');
                this.productBlocks[1].classList.add('mandatory-product');
                this.productBlocks[2].classList.add('mandatory-product');
                this.productBlocks[3].classList.add('mandatory-product');
                //remove arm from bundle
                self.addOrRemoveProduct(this.inputs[0], "remove");
                self.addOrRemoveProduct(this.inputs[4], "remove");
                self.addOrRemoveProduct(this.inputs[5], "remove");
                self.addOrRemoveProduct(this.inputs[6], "remove");
                //setting up the sale price
                this.rebuyPriceContainer = document.getElementsByClassName('rebuy-bundle__actions-price-value');
                this.htmlString = `<span class="rebuy-money-sale"></span>`;
                this.salePriceContainer = self.convertStringToHTML(this.htmlString);
                this.rebuyPriceContainer[0].append(this.salePriceContainer);
                // total price calculation
                this.totalPriceElemets = document.querySelectorAll('div.rebuy-product-block .rebuy-product-info span.rebuy-money');
                self.calculateTotalPrice(this.totalPriceElemets, true);
                // Loop through each input and attach the event listener
                for (let i = 0; i < this.inputs.length; i++) {
                    this.inputs[i].addEventListener('change', function(event) {
                        // Event handling logic goes here
                        this.tempVal = event.target.closest("div.rebuy-product-block").classList;
                        self.inputSelectionUpdated(i, event);
                    });
                }
                document.getElementsByClassName('rebuy-bundle__images')[0].classList.add('show');
                document.getElementsByClassName('rebuy-bundle__actions-price-value')[0].classList.add('show');
            }, 2000);
        });
    }

    inputSelectionUpdated(i, event) {
        // console.log("event changed ", i, event.srcElement.checked);
        const priceElements = document.querySelectorAll('div.rebuy-product-block .rebuy-product-info span.rebuy-money');
        this.calculateTotalPrice(priceElements, false);
        this.inputs = document.getElementsByClassName('checkbox-input rebuy-checkbox');
        if((i == 5 || i == 6) && event.srcElement.checked) {
            !this.inputs[4].checked ? this.addOrRemoveProduct(this.inputs[4], "add") : '';
            if( i == 5 && this.inputs[6].checked) {
                this.addOrRemoveProduct(this.inputs[6], "remove");
            } else if(i == 6 && this.inputs[5].checked) {
                this.addOrRemoveProduct(this.inputs[5], "remove");
            }
        }
        if(i == 4 && !event.srcElement.checked) {
            this.inputs[5].checked ? this.addOrRemoveProduct(this.inputs[5], "remove") : '';
            this.inputs[6].checked ? this.addOrRemoveProduct(this.inputs[6], "remove") : '';
        }
    }

    calculateTotalPrice(priceElements, check) {
        // loop through price elements
        let total = 0;
        let bundleType = 0;
        let productSalePrice = 0;
        let parentBundleType = 0;
        for(let i = 0; i < priceElements.length; i++) {
            const price = parseFloat(priceElements[i].children[1].innerText.replace('$',''));
            const isSelected = priceElements[i].parentNode.closest('div.rebuy-product-block').querySelector('input.checkbox-input.rebuy-checkbox').checked;
            if(isSelected && price > 0) {
                total += price;
            }
            // logic to updare bundle type
            if(i == 6 && isSelected) {
                bundleType = 3;
            } else if(i == 5 && isSelected) {
                bundleType = 2;
            } else if(i == 4 && isSelected) {
                bundleType = 1;
            } else {
                bundleType = 0;
            }
            // price logic 
            if(priceElements[6].parentNode.closest('div.rebuy-product-block').querySelector('input.checkbox-input.rebuy-checkbox').checked) {
                parentBundleType = 3;
            } else if(priceElements[5].parentNode.closest('div.rebuy-product-block').querySelector('input.checkbox-input.rebuy-checkbox').checked) {
                parentBundleType = 2;
            } else {
                if(priceElements[4].parentNode.closest('div.rebuy-product-block').querySelector('input.checkbox-input.rebuy-checkbox').checked) {
                    parentBundleType = 1;
                } else {
                    parentBundleType = 0;
                }
            }
            // console.log("bundleType ", bundleType);
            if(check) {
                productSalePrice = (price - (price*(this.bundleDiscounts[parentBundleType]/100))).toFixed(2);
                productSalePrice = '$' + productSalePrice;
                let saleprice = `<span class="rebuy-money-sale custom-sale">` + productSalePrice + `</span>`;
                let htmlString = this.convertStringToHTML(saleprice);
                priceElements[i].append(htmlString);
            } else {
                // console.log("sss ", priceElements[i].children[2].children[0].innerText);
                let newPrice = productSalePrice = (price - (price*(this.bundleDiscounts[parentBundleType]/100))).toFixed(2);
                newPrice = '$' + newPrice;
                priceElements[i].children[2].children[0].innerText = newPrice;
            }
        }
        total = (total - (total*(this.bundleDiscounts[bundleType]/100))).toFixed(2);
        // console.log("total ", total);
        this.rebuySalePrice = document.getElementsByClassName('rebuy-money-sale')[0];
        this.rebuySalePrice.innerText = '$'+total.toString();
        return total;
    }

    convertStringToHTML = htmlString => {
        const parser = new DOMParser();
        const html = parser.parseFromString(htmlString, 'text/html');
        return html.body;
    }

    addOrRemoveProduct(inputElement, trigger) {
        if(trigger == "remove") {
            inputElement.click();
        } else {
            inputElement.click();
        }
    }
    waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
    
            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });
    
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }
  }
  
  customElements.define('rebuy-custom', rebuyCustomizations);
  